import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');

// react-snap pre-renders the app to static HTML. When the browser loads a
// pre-rendered page, the root element already has children — in that case we
// must hydrate instead of re-rendering, otherwise React tears down the static
// markup and the user sees a flash of empty content.
if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
